import {Asset} from "../../entities/Asset";
import {PagingCtrl} from "../PagingCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";
import {CheckoutModel} from "../../models/tasks/CheckoutModel";
import {NotificationService} from "../../services/NotificationService";

export class CheckoutCtrl extends PagingCtrl<Asset>{
    public static $inject = ['$scope','$location','$state','$stateParams','PagingModel','NotificationService'];
    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService:StateParams, pagingModel:CheckoutModel,notificationService:NotificationService) {
        super($scope, $location, stateService, stateParamsService, pagingModel, notificationService);
    }
}
